<template>
  <div>
    <!-- <v-col cols="6"  sm="12" md="6" lg="6"> -->
    <v-card height="100%" class="pa-0 mb-2">
      <v-card-title v-if="Headervisible">Recent Logs</v-card-title>
      <v-container fluid>
        <!-- {{ recentList.length }} -->
        <div class="scrollbar scrolllist">
          <v-row
            v-if="recentList.length != 0"
            v-for="(item, index) in recentList"
            :key="index"
          >
            <div>
              <v-col cols="12">
                <v-row>
                  <v-col cols="4">
                    <!-- <v-avatar
                      v-bind="attrs"
                      v-on="on"
                      size="56px"
                      item
                      color="primary"
                    >
                      <span class="white--text subtitle-2 text-uppercase"
                        >RL</span
                      >
                    </v-avatar> -->
                    <v-avatar
                      v-bind="$attrs"
                      v-on="on"
                      size="56px"
                      item
                      color="primary"
                    >
                      <template v-if="item && item.user.image">
                        <img :src="item.user.image" />
                      </template>

                      <span
                        v-else
                        class="white--text subtitle-2 text-uppercase"
                        >{{
                          item.user.first_name.charAt(0) +
                          item.user.last_name.charAt(0)
                        }}</span
                      >
                    </v-avatar>
                  </v-col>
                  <v-col cols="6">
                    <h4>{{ item.activity ? item.activity : '' }}</h4>
                    <span>by {{ item.user ? item.user.first_name : '' }}</span>
                    <br />
                    <span>
                      {{ item.date }}
                    </span>
                  </v-col>
                  <v-col cols="1">
                    <v-btn
                      :color="'blue'"
                      style="height: 30px"
                      outlined
                      @click.stop="getSingleView(item.id)"
                    >
                      <v-icon style="margin-right: 5px">mdi-eye</v-icon>
                      View
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-row>
          <v-row v-if="recentList.length == 0">
            <v-col cols="12">
              <h3>No Audit Logs</h3>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-card>
    <div>
      <v-navigation-drawer
        v-model="drawer"
        width="900px"
        class="scrollclass"
        absolute
        temporary
        right
      >
        <v-list-item>
          <v-list-item-avatar v-if="items1.causer && items1.causer.image">
            <img :src="items1.causer.image" />
          </v-list-item-avatar>
          <span v-else class="white--text subtitle-2 text-uppercase">
            {{ items1.causer ? items1.causer.first_name.charAt(0) : '' }}
          </span>

          <v-list-item-content>
            <v-list-item-title
              ><b>
                {{ items1.causer ? items1.causer.first_name : '' }} ({{
                  items1.ip
                }})</b
              >
            </v-list-item-title>
            <span>{{ items1.causer ? items1.created_at : '' }}</span>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense>
          <table>
            <tbody>
              <tr>
                <th>Attributes</th>
                <th>Old Values</th>
                <th>New Values</th>
              </tr>
              <tr>
                <td>
                  <div
                    v-for="(item, index) in items1.fields"
                    :key="index"
                    style="height: 35px"
                  >
                    {{ item }}
                  </div>
                </td>
                <td>
                  <div
                    v-for="(item, index) in items1.fields"
                    :key="index"
                    style="text-align: start; margin: 1px"
                  >
                    <div
                      :style="{
                        background:
                          items1.attributes[item] != items1.old[item]
                            ? '#ffeeba'
                            : 'none',
                      }"
                      style="height: 35px; padding-top: 7px"
                    >
                      {{ items1.old[item] ? items1.old[item] : 'Null' }}
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    v-for="(item, index) in items1.fields"
                    :key="index"
                    style="text-align: start; margin: 1px"
                  >
                    <div
                      :style="{
                        background:
                          items1.attributes[item] != items1.old[item]
                            ? '#c3e6cb'
                            : 'none',
                      }"
                      style="height: 35px; padding-top: 7px"
                    >
                      {{
                        items1.attributes[item]
                          ? items1.attributes[item]
                          : 'Null'
                      }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </v-list>
      </v-navigation-drawer>
    </div>
    <!-- </v-col> -->
  </div>
</template>
<script>
import axios from '@/plugins/axios';

export default {
  props: {
    Type: {
      type: String,
      default: 'role',
    },
    Headervisible: {
      type: Boolean,
      default: true,
    },
    Typeid: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      recentList: {},
      drawer: null,

      items1: {},
      on: {
        click: console.log,
        contextmenu: console.log,
      },
    };
  },
  methods: {
    getSingleView(id) {
      axios
        .get(`audit-logs/${id}`)
        .then((res) => {
          this.drawer = 'gh';
          this.items1 = res.data.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
    GetAuditLogs() {
      let type_id = this.$route.params.id;
      axios
        .get(
          `audit-logs?type=${this.Type}&type_id=${type_id ? type_id : this.Typeid}`,
        )
        .then((res) => {
          this.recentList = res.data;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$refs.observer.setErrors(err.data.error);
        });
    },
  },
  components: {},
  created() {
    this.GetAuditLogs();
  },
};
</script>

<style scoped>
.scrolllist {
  max-height: 200px;
  width: 100%;
  overflow: auto;
}
.scrollclass {
  overflow: hidden;
}
table {
  width: 100%;
  margin: 5px;
}
</style>
